import { render } from "./uk.svg?vue&type=template&id=43551b61"
const script = {}
script.render = render

export default script